// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// 路由重复拦截
import Router from 'vue-router'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import Axios from 'axios'
import Vuex from 'vuex'
import Welcome from './views/Welcome'
import '@/model/Css/public.css'
import '@/model/Css/drop-down.css'
import dayjs from 'dayjs'
import './utils/filter'
import 'animate.css'
Vue.config.productionTip = false
Vue.prototype.$axios = Axios
Vue.prototype.dayjs = dayjs
Axios.defaults.baseURL = '/user'
Axios.defaults.headers.post['Content-Type'] = 'application/json'
Vue.use(ElementUI)
Vue.use(Vuex)

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function (location) {
  return originalPush.call(this, location).catch((err) => err)
}
/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   views: {App},
//   render: h => h(App)
// })
//
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  store: store,
  components: { App },
  template: '<App/>'
})
window.addEventListener('popstate', function () {
  history.pushState(null, null, document.URL)
})

// 添加请求拦截器，在请求头中加token
Axios.interceptors.request.use(
  config => {
    if (Welcome.methods.getLocalStorage('Authorization')) {
      config.headers.Authorization = Welcome.methods.getLocalStorage('Authorization')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  })



// WEBPACK FOOTER //
// ./src/main.js